import React from "react";
import { ToastContainer, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./notifications.scss";

// ============================================================
// Notifications (react-toastify) sur la charte : le message d'état de la
// charte, posé en carte flottante — fond pâle du ton, encre du ton,
// pictogramme à gauche, `radius` et `shadow-2` (notifications.scss).
// Réglages inchangés : bas centre, 5 s, pause au survol, clic pour fermer.
// Les appels restent `toast.success / error / warning / info(message)`.
// ============================================================

// Bouton de fermeture : libellé en français (celui de la bibliothèque est
// « close ») ; react-toastify lui passe `closeToast`.
export const BoutonFermerNotification = ({ closeToast }) => (
  <button
    type="button"
    className="notification__fermer"
    aria-label="Fermer la notification"
    title="Fermer"
    onClick={(evenement) => {
      evenement.stopPropagation();
      if (closeToast) closeToast(evenement);
    }}
  >
    <i className="fa fa-times" aria-hidden="true" />
  </button>
);

// Entrée : fondu et montée de 8 px en 200 ms ; sortie : fondu en 150 ms (au
// lieu du rebond de la bibliothèque).
export const TransitionNotification = cssTransition({
  enter: "notification-entree",
  exit: "notification-sortie",
  duration: [200, 150],
});

const Notifications = () => (
  <ToastContainer
    position="bottom-center"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnVisibilityChange
    draggable
    pauseOnHover
    transition={TransitionNotification}
    closeButton={<BoutonFermerNotification />}
  />
);

export default Notifications;
